import {
  cn
} from "./O62HZC57.jsx";

// src/StatusBadge/StatusBadge.tsx
import { Show } from "solid-js";
var StatusBadge = (props) => {
  return <Show when={props.status && props.statusMap[props.status]}>
      <span class={cn("bg-current-alpha rounded-full px-2 py-0.5 text-xs", props.statusMap[props.status].color, props.class)}>
        {props.statusMap[props.status].label}
      </span>
    </Show>;
};

export {
  StatusBadge
};
